<div class="mt-3" *ngIf="{
    isWL: WL.isWhiteLabel | async,
    props: WLprops$ | async
  } as WLd">
  <!-- Homepage link -->
  <a class="btn btn-link d-inline-block text-secondary ml-4" href="https://{{ production ? '' : 'test.' }}getapollo.io"
    *ngIf="!WLd.isWL"><i class="fe fe-arrow-left"></i> {{ 'Home' | translate }}</a>

  <button type="button" class="btn btn-link d-inline-block text-secondary" routerLink="/login" *ngIf="!WLd.isWL || !WLd.props.hideLoginPage">
    {{ 'Login' | translate }}
  </button>

  <a class="btn btn-link d-inline-block text-secondary" href="{{ WLd.props.signupURL }}"
    *ngIf="WLd.isWhiteLabel && WLd.props.signupURL">
    {{ 'Signup' | translate }}
  </a>

  <button class="btn btn-link d-inline-block text-secondary" routerLink="/signup"
    *ngIf="!WLd.isWL || WLd.props.showSignup">
    {{ 'Signup' | translate }}
  </button>
</div>

<router-outlet></router-outlet>
